import fileDownload from 'js-file-download';

/* istanbul ignore next */
export const saveAs = (blob, filename) => {
    fileDownload(blob, filename);
};